/**
 * Día del negocio en el POS — espejo de
 * `services/pos-floor/src/services/business-day.ts` (F6.6).
 *
 * 🔴 El bug que esto cierra: agrupar reservas por `reservedAt.slice(0, 10)`
 * toma el día **UTC**. México va 6 h atrás, así que una reserva de las 21:00
 * aparecía en el día SIGUIENTE del calendario (medido 2026-08-20: las 21:00
 * CDMX son las 03:00Z del 21). El admin la mostraba bien y el POS no.
 *
 * El servidor ya calcula el día correcto con la zona del negocio EXPLÍCITA y lo
 * expone como `reservationDay`; aquí se prefiere ese valor y sólo se cae al día
 * local del navegador si la fila no lo trae.
 */

/** Día LOCAL (no UTC) de un instante ISO. `slice(0,10)` daría el día UTC. */
export function localDayOf(iso: string): string {
  const d = new Date(iso)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

/** Día del negocio de una reserva: el del servidor si viene, si no el local. */
export function businessDayOf(row: { reservationDay?: string | null; reservedAt: string }): string {
  const day = row.reservationDay
  return day !== null && day !== undefined && day !== '' ? day.slice(0, 10) : localDayOf(row.reservedAt)
}
